@if (savedCart$ | async; as cart) {
  <div class="cx-cart-summary">
    <div class="container">
      <div class="cx-summary-card">
        <div class="cx-edit-container">
          <cx-card [content]="getCartName(cart?.name) | async"></cx-card>
          @if (!isRestricted) {
            <button class="cx-edit-cart" #element (click)="openDialog(cart)">
              <cx-icon [type]="iconTypes.PENCIL"></cx-icon>
            </button>
          }
        </div>
        <div class="cx-card-description">
          <cx-card
            [content]="getCartDescription(cart?.description) | async"
            [truncateText]="true"
            [charactersLimit]="30"
          ></cx-card>
        </div>
      </div>
      <div class="cx-summary-card">
        <cx-card [content]="getCartId(cart?.code) | async"></cx-card>
        <div class="cx-card">
          <div class="card-body cx-card-body">
            <h4 class="cx-card-title">
              {{ 'customSavedCartDetails.publicCart' | cxTranslate }}
            </h4>
            @if (!isOwner) {
              <div>
                {{ 'customSavedCartDetails.yes' | cxTranslate }}
              </div>
            }
            @if (isOwner) {
              <div class="form-group row">
                <div class="col-5 col-form-label">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="public"
                      id="public"
                      [value]="true"
                      ng-control="public"
                      [(ngModel)]="publicCart"
                      (change)="onChangePublicFlag()"
                      [disabled]="isRestricted"
                      />
                      <label class="form-check-label" for="public">
                        {{ 'customSavedCartDetails.yes' | cxTranslate }}
                      </label>
                    </div>
                  </div>
                  <div class="col-5 col-form-label">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="private"
                        id="private"
                        [value]="false"
                        ng-control="private"
                        [(ngModel)]="publicCart"
                        (change)="onChangePublicFlag()"
                        [disabled]="isRestricted"
                        />
                        <label class="form-check-label" for="private">
                          {{ 'customSavedCartDetails.no' | cxTranslate }}
                        </label>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="cx-summary-card">
            <cx-card [content]="getDateSaved(cart?.saveTime) | async"></cx-card>
            <cx-card [content]="getCartItems(cart?.totalItems) | async"></cx-card>
          </div>
          <div class="cx-summary-card">
            <cx-card
              [content]="getCartQuantity(cart?.totalUnitCount) | async"
            ></cx-card>
            <cx-card
            [content]="
              getCartTotal(cart?.totalPriceWithTax?.formattedValue) | async
            "
            ></cx-card>
          </div>
        </div>
      </div>
    }
